<template>
  <span>
    <i :class="statusList[status].icon"></i> {{ statusList[status].description }}
  </span>
</template>

<script>

  import ExamRequestService from "@/services/exam-request-service"

  export default {

    data() {
      return {
        statusList: ExamRequestService.STATUS,
      }
    },

    props: ["status"], 

  }
</script>